import { Slider } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import React from "react";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import {
  primarySleeperFirmnessSelector,
  secondarySleeperFirmnessSelector,
  setPrimarySleeperFirmness,
  setSecondarySleeperFirmness,
} from "../../../../redux/slices/mattressConfiguration";
import sliderBrick from "../../../../assets/images/sliderBricks.svg";
import sliderCloud from "../../../../assets/images/sliderCloud.svg";
import { currentlyEditingSleeperSelector } from "../../../../redux/slices/customNavigation";

const FirmnessSlider = ({ primary = true }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const primarySleeperFirmness = useSelector(primarySleeperFirmnessSelector);
  const secondarySleeperFirmness = useSelector(
    secondarySleeperFirmnessSelector
  );
  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);

  const editingSleeper1 = currentlyEditingSleeper === 1;

  const getValue = () => {
    if (editingSleeper1) {
      return primarySleeperFirmness;
    } else {
      return secondarySleeperFirmness;
    }
  };

  const marks = [
    {
      value: 1,
      // label: (
      //   <div style={{ fontSize: "1rem", color: "#0F475D", fontWeight: "bold", width:"1vw", height:"20vh" }}>
      //     {t("The softer, the better!")}
      //   </div>
      // ),
      label: "Soft",
    },
    {
      value: 2,
      label: "Medium Soft",
    },
    {
      value: 3,
      label: "Medium",
    },
    {
      value: 4,
      label: "Medium Firm",
    },
    {
      value: 5,
      // label: (
      //   <div style={{ fontSize: "1rem", color: "#0F475D", fontWeight: "bold", width:"1vw", height:"20vh" }}>
      //     {t("Extra firm, please!")}
      //   </div>
      // ),
      label: "Firm"
    },
  ];

  const handleOnChange = event => {
    if (editingSleeper1) {
      dispatch(setPrimarySleeperFirmness(event.target.value));
    } else {
      dispatch(setSecondarySleeperFirmness(event.target.value));
    }
  };

  return (
    <div
      style={{
        // marginTop: "10%",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
        className="w-75 mx-auto"
      >
        <div>
          <img
            style={{ height: "3vh", marginLeft: "-1vw" }}
            src={sliderCloud}
          ></img>
        </div>
        <div>
          <img
            style={{ height: "3vh", marginRight: "-1vw" }}
            src={sliderBrick}
          ></img>
        </div>
      </div>
      <div className="row flex justify-content-between align-items-center w-75 mx-auto">
        <Slider
          aria-label="Mattress Firmness"
          defaultValue={1}
          // color="#52af77"
          value={getValue()}
          min={1}
          max={5}
          step={null}
          componentsProps={{}}
          marks={marks}
          onChange={handleOnChange}
          sx={{ fontSize: "3rem", color: theme.COLORS.BLUE.darkBlueGreen }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
        className="w-75 mx-auto"
      >
        <div
          style={{
            fontSize: "1rem",
            color: "#0F475D",
            fontWeight: "bold",
            width: "35%",
            textAlign: "center",
            marginLeft: "-2vw",
            marginTop: "1vh"
          }}
        >
          {t("The softer, the better!")}
        </div>
        <div
          style={{
            fontSize: "1rem",
            color: "#0F475D",
            fontWeight: "bold",
            width: "35%",
            textAlign: "center",
            marginRight: "-2vw",
            marginTop: "1vh"
          }}
        >
          {t("Extra firm, please!")}
        </div>
      </div>
    </div>
  );
};

export default FirmnessSlider;
